import { Displays, Menus } from "blx-icons"
import type { NavigationLinkItem } from "config/navigation/types/NavigationLinkItem"
import { BLXApplications } from "config/routing"
import useBMRoutes from "./useBMRoutes"

const buildNavigationLinkItem = (
    navItem: Omit<NavigationLinkItem, "application" | "displayType" | "isDisabled">
): NavigationLinkItem => ({
    ...navItem,
    application: BLXApplications.BrewMenu,
    displayType: "link",
    isDisabled: false
})
interface BMRouteNavigationLinkItems {
    menusLinkItem: NavigationLinkItem
    displaysLinkItem: NavigationLinkItem
    preferencesLinkItem: NavigationLinkItem
    pricingLinkItem: NavigationLinkItem
    brewMenuMainNavConfig: NavigationLinkItem[]
    brewMenuSettingsConfig: NavigationLinkItem[]
}

export const useBMRouteNavigationLinkItems = (): BMRouteNavigationLinkItems => {
    const { displays, menus, preferences, pricing, staticRoutes } = useBMRoutes()

    const { displaysStatic, menusStatic, brewMenuPricingStatic, brewMenuPreferencesStatic } =
        staticRoutes

    const menusLinkItem = buildNavigationLinkItem({
        icon: Menus,
        label: "Menus",
        path: menus(),
        styleMatchingPath: menusStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    const displaysLinkItem = buildNavigationLinkItem({
        icon: Displays,
        label: "Displays",
        path: displays(),
        styleMatchingPath: displaysStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    const preferencesLinkItem = buildNavigationLinkItem({
        icon: null,
        label: "Preferences",
        path: preferences(),
        styleMatchingPath: brewMenuPreferencesStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    const pricingLinkItem = buildNavigationLinkItem({
        icon: null,
        label: "Pricing",
        path: pricing(),
        styleMatchingPath: brewMenuPricingStatic,
        permittedRoles: ["admin", "owner", "staff"]
    })

    // Link Item Groups
    const brewMenuMainNavConfig = [menusLinkItem, displaysLinkItem]
    const brewMenuSettingsConfig = [preferencesLinkItem, pricingLinkItem]

    return {
        menusLinkItem,
        displaysLinkItem,
        preferencesLinkItem,
        pricingLinkItem,
        brewMenuMainNavConfig,
        brewMenuSettingsConfig
    }
}
